













































import { defineComponent } from "@vue/composition-api";
import BaseImage from "@/components/BaseImage";
import { policies, company, socialLinks } from "./config";
import LandingContainer from "../LandingContainer";

export default defineComponent({
  name: "FooterBlock",
  components: { BaseImage, LandingContainer },
  setup() {
    const year = new Date().getFullYear();
    return {
      year,
      policies,
      company,
      socialLinks,
    };
  },
});
